import { ReportType } from "../../../types/types";
import { api } from "../api";

/**
 * generatePositionsMapByVehicle - Function that finds on database an list of positions of vehicles to show it on the map
 * /reports/{status}/maps
 * method POST 
 * @async-function
 */
const generatePositionsMapByVehicle = async (token: string, model: ReportType, status: string) => {
    const response = await api.post(
        `/reports/${status}/maps`, { ...model }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default generatePositionsMapByVehicle;